import { LOCATION_CHANGE } from 'connected-react-router';
import moment from 'moment';


import {
    CRUD_GET_ONE_SUCCESS,
} from 'store/actions/dataActions';
import { REFRESH_VIEW } from 'store/actions/listActions';


const initialState = null;
export default (previousState = initialState, { type, payload, requestPayload, meta, error }) => {

  switch (type) {

    case CRUD_GET_ONE_SUCCESS:
      return { ...payload, timestamp: moment().toString() };

    case LOCATION_CHANGE:
    case REFRESH_VIEW:
      return null;

    default:
      return previousState;
  }

};
